import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import qs from 'qs';

import './style.css';
import Button from "@mui/material/Button";


export default function Login(props) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        const code = qs.parse(props.location.search, { ignoreQueryPrefix: true }).code;
        if(code){
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({code: code, redirectUri: process.env.REACT_APP_BASE_URL+'/login'})
            };
            const url = process.env.REACT_APP_API_BASE_URL + '/auth/line/token';
            fetch(url, requestOptions)
                .then(results => results.json())
                .then(data => {
                    setLoading(false);
                    if(data.token){
                        localStorage.setItem('admin-token', data.token);
                        if(data.accountId){
                            history.push('/home');
                        }
                    } else {
                        localStorage.removeItem('admin-token');
                        history.push('/login');
                    }
                });
        } else {
            setLoading(false);
        }
    }, [history, props]);

    const handleClick = () => {
        history.push('/signin');
    };

    return (
        <div>
            {loading &&
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress size={20}/>
            </Box>
            }
            {!loading &&
                <>
                    <Container>
                        <Card style={{marginTop: '1rem'}}>
                            <CardContent>
                                <Box display="flex" justifyContent="center" pt={4}>
                                    <img alt="FoodKub" src={`${process.env.REACT_APP_CDN_BASE_URL}/public/assets/foodkub-admin.png`} width="200px" />
                                </Box>
                                <Box display="flex" justifyContent="center" pt={4}>
                                    <Button
                                        sx={{color: '#FFFFFF',
                                            padding: '6px 16px',
                                            backgroundColor: '#00C300',
                                            '&:hover': {
                                                backgroundColor: '#00E000',
                                            },
                                            '&:active': {
                                                backgroundColor: '#00B300',
                                            }}}
                                        variant="contained"
                                        disableElevation
                                        size="large"
                                        startIcon={<img alt="LINE" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDphNTk0YTczYS0zNzEzLTRhMjktODgyYi0xYjg0ZWJkMjM5NGQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEFCNUUyREQ5M0YwMTFFNDk1OEFENjBBMUJBQjkyMzkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEFCNUUyREM5M0YwMTFFNDk1OEFENjBBMUJBQjkyMzkiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6YzU4NjU0YTItOWNhYy00OWU0LThkNjgtMmMwZjU4OTkxNjIzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmE1OTRhNzNhLTM3MTMtNGEyOS04ODJiLTFiODRlYmQyMzk0ZCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pg+/OCAAAAHESURBVHja7Ne/LwNhGMDxHiUkEhODxHIlYRKLWPzYDMIowUhsIiLB4EeCwURC/AsSi6G7FDWKBG3CoNIBCWnoJFp6vpc8w5vmGu/bXnTpk3yGe+7ufZ/eve97by3HcQLljKpAmaNSQKWAoOH1XRjBAEJolvwrHnCOMK61W3SnoYZBRBz9iMg9f7b91wVB7CHnmEdO7g0WW0A1jp3S41jaMi5g0/Evtgr1YxVYim3cocanwZ5FpwxUrWk4rXT+g0V8y3Ea60hhSc67sSG5WYxhHEk557Y1ZTIL4srj+5BcUo5v0Iio5Nckr+aWsY0XpZ24V1+FnoCt+WhrsYtTj3NW3jpjm6yEn5oF1EsBk8go+Vtc4r3YpTjhkbvAiQwoNdx325dX9ARm0KrkYiZjYF15d1/oho02nGEIjxhWxkk/EuiRa0O4UtpZNZmGLbhHg0/TMC3fjpTuK3jGio8fvTmvznU+Rvs+rII7pXyMXPMyDoqJA1ilFhCQwXeEjGbHWSzotG0ZbsubZUPSK5uSdo9rnmQZjvq5IfHiFh/L++VhNJm0U8qeUH10KVkNR/H2n5vSOuyjA4fFNGBV/ppVCih3Ab8CDAAenITLwKlYUgAAAABJRU5ErkJggg==" />}
                                        onClick={(e) => handleClick(e)}
                                    >
                                        {t('login.line')}
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Container>
                </>
            }
        </div>
    )
}